import React from 'react'
import { CircularProgress, TableBody, TableCell, TableRow } from '@material-ui/core'
import { Order } from '.'
import { useSelector } from 'react-redux'
import { selectPrepaymentAmount } from './state/prepaymentsSlice'

interface Props {
  users: any[]
  isNumeric?: boolean
  order?: Order
  orderBy?: string
  rowsPerPage: number
  page: number
  isDateSort?: boolean
  isLoading: boolean
  isTeam: boolean
}

const TrackingBody: React.FC<Props> = ({ users, isLoading }) => {
  const prepaymentAmount = useSelector(selectPrepaymentAmount)

  const currencyFormat = (num: number) => {
    const round = Math.round(num)
    return `$ ${round.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
  }
  if (isLoading)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '60vh',
          width: '100vw'
        }}
      >
        <CircularProgress style={{ color: '#ff6900' }} />
      </div>
    )
  return (
    <>
      <TableBody>
        {users.map(user => {
          return (
            <TableRow className="table-row--container" key={user._id}>
              <TableCell align="left">{user.name}</TableCell>
              <TableCell align="center">{user.stages.office}</TableCell>
              <TableCell align="center">{user.stages.success}</TableCell>
              <TableCell align="center">{currencyFormat(user.stages.fee)}</TableCell>
              <TableCell align="center">{currencyFormat(user.stages.fee / 1.19)}</TableCell>
              <TableCell align="center">{currencyFormat(users.length >= 3 ? prepaymentAmount : 0)}</TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </>
  )
}

export default TrackingBody
